import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import csvHelper from '../importjsontocsv';
import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'brandwisestockreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	props: [],
	fields: [],

	data() {
		return {
			limitExeed: false,

			downloadype: '',
			exceedsize: false,
			listMerchantData: [],
			listStockReportData: [],
			listvirtualstockCsv: [],
			listvirtualstockXls: [],
			dataFilter2: '',
			listStockReportFinalData: [],
			listsubinventoryData: [],
			subinventory: '',
			csvFields: [],
			csvFieldsForXls: {},
			// perPage: 10,
			// pageno: 0,
			// totalPage: 0,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,

			POID: '',
			InvoiceID: '',
			RackID: '',
			ProductID: '',
			merchantname: '',
			fromdate: '',
			todate: '',
			isLoading: false,
			isLoadingforxls: false,
			formattedDate: '',
			reportname: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			stocktype: '',
			stocktypeErr: '',
			user_type: '',
			inventory: 'All',
			userid: '',
			show: false,
			download: true,
			recordLimit: 0,
			exceedFlag: false,
			lesslimitflag: false,
			item: {},
			merchant: '',
			listMerchantData1: [],
			merchantList: [],
			merchantname: '',
			activemrpflag: false,
			showmodal: false,
			reasonEmpty: '',
			listvirtualstock: [],
			selectedVirtualStock: {}
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY hh:mm:ss');
		}
	},
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('userProperties.VirtualInventory')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		//this.getStockReportData();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.loginUserEmail = userdetail.email;
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.loginUserEmail = userdetail.email;
				this.clientid = userdetail.clientid;
				this.showSelectWarehouse = true;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getActiveMrpFlag();
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchantname = item.value
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getvirtualInventory(3)
			}
		},

		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;

					}
				}, error => {
					console.error(error)
				})
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantname = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 			this.getActiveMrpFlag();
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.item = {}
		// 			this.getActiveMrpFlag();
		// 		}
		// 	}
		// 	this.listStockReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getStockReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getvirtualInventory(csvCheck) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.exceedFlag = false;
			var dataFilter = {};

			this.searchFlag = true;
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listvirtualstock = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listvirtualstock = [];
				return false;
			}
			let params = {
				offset: (this.currentPage - 1) * this.pageLimit,
				limit: this.pageLimit,
			};

			if (window.localStorage.getItem("selectedClient")) {
				params.clientid = window.localStorage.getItem("selectedClient");
			}
			if (window.localStorage.getItem("selectedWarehouse")) {
				params.warehouseid = window.localStorage.getItem("selectedWarehouse");
			}

			if (this.stocktype) {
				params.stocktype = this.stocktype;
			} else {
				this.stocktypeErr = this.$t('common.stockTypeRequired')
				this.isLoading = false
				return false
			}

			if (this.ProductID) {
				params.productid = this.ProductID;
			}
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false

			}
			else if (csvCheck == 3) {
				this.show = true;
				this.download = false;
				var value = '';
				var str = '';

				Object.entries(params).forEach(([k, v]) => {
					let skipkeys = ['offset', 'limit', 'csvData'];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						value += k + ':' + v + ','
						this.dataFilter2 = str.concat(value);

					}

				})
			} else {

				Object.entries(params).forEach(([k, v]) => {
					let skipkeys = ['offset', 'limit', 'csvData'];
					if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
						dataFilter[k] = v;
					}
				})
			}
			params.iscsv = csvCheck
			params.userid = this.userid
			this.isLoading = true;

			axios({
				method: 'GET',
				url: `${apiUrl.api_url}virtualInventory`,
				params: params,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(response => {
					if (csvCheck == 1) {

						if (response.data.data.length > 0) {

							this.listvirtualstockCsv = [];
							this.show = true;
							this.download = false;

							this.csvFields = {

								'eancode': this.$t('common.eanCode'),
								'productname': this.$t('common.productName'),
								'virtualstock': this.$t('userProperties.VirtualStock'),


							};
							var dateFilder = [];
							var skipFilter = ['rowcount'];

							this.listvirtualstockCsv = response.data.data.filter(function (el) { return delete el.productid, delete el.warehouseid, delete el.jsonb_agg, delete el.rowcount, delete el.stocklist, delete el.mrp, delete el.stocktype,delete el.rackid });
							csvHelper.data.jsonToCSV(this.$t('userProperties.VirtualInventory'), this.listvirtualstockCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
							this.isLoading = false

						} else {
							if (response.data.status == true && this.limitExeed) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(response.data.msg.message);
							}
							this.isLoading = false
						}
					}
					else if (csvCheck == 3) {

						if (response.data.data.length > 0) {

							this.listvirtualstockXls = [];
							this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
							this.csvFieldsForXls[this.$t('common.productName')] = 'productname';
							this.csvFieldsForXls[this.$t('userProperties.VirtualStock')] = 'virtualstock';
							this.listvirtualstockXls = response.data.data.filter(function (el) { return delete el.productid, delete el.warehouseid, delete el.jsonb_agg, delete el.rowcount, delete el.stocklist, delete el.mrp, delete el.stocktype, delete el.rackid });;
							this.totalRows = response.data.count;


						} else {
							this.listvirtualstockXls = [];
							if (response.data.status == true && this.limitExeed) {
								this.$alertify.success(this.$t('common.reportSizeError'));
								this.isLoading = false
							} else {
								this.$alertify.error(response.data.msg.message);
								this.isLoading = false
							}
						}
						this.isLoading = false

					}
					else {
						this.listvirtualstock = response.data.data;
						this.isLoading = false;
						this.totalRows = response.data.count;
						this.resultCount = response.data.count;
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		downloadxlsexceed() {
			console.log('downloadxlsexceed function called', this.exceedsize); // Check if the function is called
			if (this.exceedsize) {
				this.getvirtualInventory(3)
			}
		},
		openmodalEmptystock(data) {
			this.selectedVirtualStock = data;
			this.showmodal = true; // Show the modal
			this.reasonEmpty = ''
		},

		updateVirtualInventory() {


			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.showmodal = true;
			this.isLoading = true;

			let params = {};
			params = {
				productRackStockIDs: [...this.selectedVirtualStock.stocklist],
				totalvirtualstock: this.selectedVirtualStock.virtualstock,
				useremail: this.loginUserEmail
			}
			if (window.localStorage.getItem("selectedClient")) {
				params.clientid = window.localStorage.getItem("selectedClient")
			}
			if (window.localStorage.getItem("selectedWarehouse")) {
				params.warehouseid = window.localStorage.getItem("selectedWarehouse");
			}

			if (this.selectedVirtualStock.stocktype) {
				params.stocktype = this.selectedVirtualStock.stocktype;
			} else {
				this.$alertify.error(this.$t('common.stockTypeRequired'))
				this.isLoading = false
				return false
			}
			if (this.reasonEmpty) {
				params.comment = this.reasonEmpty
			} else {
				this.$alertify.error(this.$t('userProperties.ProvideSomeReason'))
				this.isLoading = false
				return false
			}
			params.mrp = this.selectedVirtualStock.mrp
			params.rackid = this.selectedVirtualStock.rackid
			axios({
				method: 'PUT',
				url: `${apiUrl.api_url}updateVirtualInventory/${this.selectedVirtualStock.productid}`,
				data: params,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(response => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(response.data.msg)
						this.isLoading = false
						this.showmodal = false
						this.getvirtualInventory(2)
					} else {
						this.$alertify.error(response.data.msg)
						this.isLoading = false
						this.showmodal = false
					}
				})
				.catch(error => {
					console.error(error);
				});
		},

		async getActiveMrpFlag() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				"clientid": window.localStorage.getItem("selectedClient"),
			});
			try {

				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'checkActivemrpFlg',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
					.then(result => {
						if (result.data.data.data[0].value === 'yes') {
							this.activemrpflag = true;
						} else {
							this.activemrpflag = false;
						}
					}, error => {
						console.error(error);
					});

			} catch (err) {
				throw new Error(err);
			}
		},



		onPageChange(page) {
			this.currentPage = page;
			this.getvirtualInventory(2)
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.POID = '';
			this.InvoiceID = '';
			this.RackID = '';
			this.ProductID = '';
			this.fromdate = '';
			this.todate = '';
			this.merchantname = '',
				this.subinventory = '',
				this.pageno = 0;
			this.totalRows = 0;
			this.stocktype = '';
			this.inventory = 'All';
			this.searchFlag = false;
			this.listStockReportData = [];
			this.listvirtualstock = []
			this.item = {}
			this.reasonEmpty = ''
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
			//this.getStockReportData();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/virtualstockreport/virtualstockreport.component.js